<template>
  <div class="home">
    <div class="head-title">预付费</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="onSubmit = true"
            >添加预付费</el-button
          >
          <el-table
            :data="tableData.data"
            border
            
            style="width: 100%; text-aligh: center; margin-top: 2.0rem"
          >
            <el-table-column
              prop="money"
              label="储蓄金额"
              width="220"
            ></el-table-column>
            <el-table-column
              prop="money_photo"
              label="付款凭证"
              width="120"
            >
              <template slot-scope="scope">
                <el-image
                  style="width: 7.0rem; height: 7.0rem"
                  :src="`${scope.row.money_photo}`"
                  :preview-src-list="[scope.row.money_photo]"
                  fit="scale-down"></el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="money_explain"
              label="储值说明"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="if_status" label="审核" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.if_status == '1'">
                  <span class="dengdai">等待审核中</span>
                </div>
                <div v-if="scope.row.if_status == '2'">
                  <span class="tongg">通过</span>
                </div>
                <div v-if="scope.row.if_status == '3'">
                  <span class="bohui">驳回</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="back_content"
              label="驳回内容"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <div
                  v-if="
                    scope.row.if_status == '1' || scope.row.if_status == '3'
                  "
                >
                  <el-button
                    type="text"
                    @click="dele(scope.row.id)"
                    style="color: #f00 !important"
                  >
                    删除
                  </el-button>
                  <el-button
                    type="text"
                    @click="
                      (dialogVisible = true),
                        modify(
                          scope.row.id,
                          scope.row.money,
                          scope.row.money_explain
                        )
                    "
                    style="color: #fff"
                  >
                    编辑
                  </el-button>
                </div>
                <div v-else-if="scope.row.if_status == '2'">
                  <span class="tongg">通过√</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="headlgetAgentUser"
            />
          </div>
        </div>
        <el-dialog title="修改权限" center  :visible.sync="dialogVisible" width="30%">
          <el-form ref="form" :model="form" label-width="8.0rem">
            <el-form-item label="修改权限">
              <el-input clearable v-model="dengj">{{ dengj }}</el-input>
            </el-form-item>
            <el-form-item label="付款凭证">
              <el-upload
                class="upload-demo"
                :action="
                  `${baseURL}/api/Alioss/uploadTotal?agenttoken=` +
                  username.agenttoken
                "
                :on-preview="handlePreviewn"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                @click="shang"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :on-success="chenggongn"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="修改售价">
              <el-input clearable v-model="shoujia">{{ shoujia }}</el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="vak()">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="添加预付费" center  :visible.sync="onSubmit" width="30%">
          <el-form ref="form" :model="form" label-width="11.0rem">
            <el-form-item label="储蓄金额">
              <el-input clearable v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="付款凭证">
              <el-upload
                class="upload-demo"
                :action="
                  `${baseURL}/api/Alioss/uploadTotal?agenttoken=` +
                  username.agenttoken
                "
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :on-success="chenggong"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="储值说明">
              <el-input clearable v-model="form.money"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="onSubmit = false">取 消</el-button>
            <el-button type="primary" @click="numoo()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      url: "https://api.weijub.com",
      tableData: {
        total: 0,
        data: [],
      },
      formInline: {
        user: "",
      },
      dialogVisible: false,
      form: {
        name: "",
        money: "",
        url: "",
      },
      onSubmit: false,
      modifys: "", //修改点击来接收的id,
      dengj: "", //获取修改名称的
      shoujia: "", //获取修改售价的
      fileList: [], //图片上传
      newList: { 1: "等待审核中", 2: "通过", 3: "驳回" },
      username: {},
      baseURL: this.axios.defaults.baseURL,
      title: {},
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
      // this.username = JSON.parse(window.sessionStorage.getItem("userinfo")).username;
    }

    this.headlgetMoneyList();
  },
  methods: {
    //  通过点击事件触发监听事件
    headlgetMoneyList() {
      this.axios
        .post(
          "/api/money/getMoneyList",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
            page: this.listQuery.page
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData.total = res.data.count;
          this.tableData.data = res.data.data;
        });
    },
    //图片上传
    chenggong(response, file, fileList) {
      this.form.url = file.response.data;
    },
    //图片删除后返回的信息
    handleRemove(file, fileList) {},
    shang() {
      this.form.url = file.response.data;
    },
    //上传成功后点击返回的图片信息
    handlePreview(file) {
      this.form.url = file.response.data;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    chenggongn(response, file, fileList) {
      this.form.url = file.response.data;
    },
    handlePreviewn(file) {
      this.form.url = file.response.data;
    },
    modify(e, l, o, b) {
      this.form.url = b;
      this.modifys = e;
      this.dengj = l;
      this.shoujia = o;
    },
    vak() {
      // 修改代理商等级
      var bbb = this.shoujia;
      var aaa = this.dengj;
      if (aaa !== "" && bbb !== "") {
        this.axios
          .post(
            "/api/money/editMoney",
            qs.stringify({
              agent_id: this.username.id,
              money: this.dengj,
              money_photo: this.form.url,
              money_explain: this.shoujia,
              id: this.modifys,
              agenttoken: this.username.agenttoken,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/mine");
            }
            this.headlgetMoneyList();
            if (res.data.code == 1) {
              this.dialogVisible = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.dialogVisible = true;
              this.$message.error(res.data.msg);
            }
          })
          .catch(function (err) {});
      } else {
        this.$message({
          message: "修改权限不能为空",
          type: "success",
        });
        return;
      }
    },

    handleClick(row) {},
    // 删除代理等级管理
    dele(e) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/api/money/delMoney",
              qs.stringify({
                id: e,
                agenttoken: this.username.agenttoken,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/mine");
              }
              this.headlgetMoneyList();

              this.$message.error(res.data.msg);
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "取消删除",
            type: "success",
          });
        });
    },
    // 添加用户信息
    numoo() {
      if (this.form.name !== "") {
        this.axios
          .post(
            "/api/money/addMoney",
            qs.stringify({
              agent_id: this.username.id,
              money: this.form.name, //金额
              money_photo: this.form.url,
              money_explain: this.form.money, //说明
              agenttoken: this.username.agenttoken,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/mine");
            }
            if (res.data.code == 1) {
              this.onSubmit = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else if (res.data.code == 0) {
              this.onSubmit = true;
              this.$message.error(res.data.msg);
            }
            this.headlgetMoneyList();

            // window.location.replace("http://localhost:8080/about/grade");
          })
          .catch(function (err) {});
      } else {
        this.$message({
          message: "添加权限不能为空",
          type: "success",
        });
        return;
      }
    },
    transignificance(val, type) {
      for (const key in type) {
        if (key * 1 === val) {
          return type[key];
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table thead {
  color: #FFFFFF;
}
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  margin-top: 2.0rem;
  width: 100%;
  height: 90%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 1.0rem 31px;
}
.tongg {
  color: green;
}
.dengdai {
  color: rgb(64, 158, 255);
}
.bohui {
  color: red;
}
.tianjia {
  width: 100%;
  height: 100%;
}
.tianjia > main {
  font-size: 26px;
  /* margin-bottom: 4.0rem; */
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
</style>

